import { Footer } from '@soteria/design-system-ve';
import { Link } from 'react-router-dom';

export function PageFooter() {
  return (
    <Footer
      links={[{ href: 'https://www.microsoft.com/en-us/privacy/privacystatement', label: 'Privacy and cookies' }]}
      logo={<img alt="Xbox" height={28} src="https://logincdn.msftauth.net/shared/5/images/xbox_logo_white_cde084563e169a9848af.svg" width={90} />}
      renderLink={(link, className) => (
        <Link className={className} to={link.href}>
          {link.label}
        </Link>
      )}
    />
  );
}
